// extracted by mini-css-extract-plugin
export var hidden = "_ti-0";